import { marketingColors } from "../../app/components/tickitMarketingTheme";

export function getBrandingColors(branding = {}) {
  const primary = branding.primaryColor || marketingColors.p700;
  const accent = branding.accentColor || primary;
  return { primary, accent };
}

/** MUI field styles using accent color for labels, values, and borders. */
export function brandedFieldSx(accent) {
  const color = accent || marketingColors.gray700;
  return {
    "& .MuiInputLabel-root": { color, fontWeight: 500, opacity: 0.9 },
    "& .MuiOutlinedInput-input": { color },
    "& .MuiSelect-select": { color },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": { borderColor: `${color}55` },
      "&:hover fieldset": { borderColor: `${color}99` },
      "&.Mui-focused fieldset": { borderColor: color },
    },
    "& .MuiInputLabel-root.Mui-focused": { color, opacity: 1 },
    "& .MuiFormHelperText-root": { color, opacity: 0.85 },
  };
}

export function brandedTextSx(accent) {
  const color = accent || marketingColors.gray700;
  return { color, fontFamily: "inherit" };
}

/** Categories may store `available` as boolean or string depending on create/edit flow. */
export function isCategoryAvailable(cat) {
  if (!cat) return false;
  const v = cat.available;
  if (v === false || v === "false" || v === 0 || v === "0") return false;
  if (v === true || v === "true" || v === 1 || v === "1") return true;
  return true;
}

/** MuiPhoneNumber styles aligned with branded TextField outlined inputs. */
export function brandedPhoneFieldSx(accent) {
  const color = accent || marketingColors.gray700;
  return {
    ...brandedFieldSx(color),
    width: "100%",
    "& .MuiInputBase-root": { minHeight: 48 },
    "& .MuiInputBase-input": {
      fontSize: { xs: "0.9rem", sm: "1rem" },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      minHeight: 48,
      "& fieldset": { borderColor: `${color}55` },
      "&:hover fieldset": { borderColor: `${color}99` },
      "&.Mui-focused fieldset": { borderColor: color },
      "& .flag-dropdown": {
        borderRight: `1px solid ${color}33`,
        borderRadius: "8px 0 0 8px",
      },
    },
    "& .MuiInputLabel-root": { color, fontWeight: 500, opacity: 0.9 },
    "& .MuiInputLabel-root.Mui-focused": { color, opacity: 1 },
  };
}
